export default __webpack_public_path__ + "static/media/polaroid-dark.28d03ec9.png";